export default "__VITE_ASSET__8758629f__"